// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BPoX","content":"styles_content__1L6JI","row":"styles_row__3iYFI","footer":"styles_footer__2QGHu","phraseLength":"styles_phraseLength__2XY4m"};